/**
 * @class Database
 */
export default class Database {
    /**
     * @param {String}  uuid
     * @param {String}  masterUuid
     * @param {String}  name
     * @param {Object}  main
     * @param {Object}  local
     * @param {Boolean} available
     * @param {String}  note
     * @param {Number}  status
     */
    constructor(uuid, masterUuid, name, main, local, available, note, status) {
        this._uuid = uuid;
        this._masterUuid = masterUuid;
        this._name = name;
        this._main = main;
        this._local = local;
        this._hasAvailableCompatibleServers = available;
        this._note = note;
        this._status = status;
    }

    /**
     * @return {String}
     */
    get uuid() {
        return this._uuid;
    }

    /**
     * @param {String} uuid
     */
    set uuid(uuid) {
        this._uuid = uuid;
    }

    /**
     * @return {String}
     */
    get masterUuid() {
        return this._masterUuid;
    }

    /**
     * @param {String} masterUuid
     */
    set masterUuid(masterUuid) {
        this._masterUuid = masterUuid;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {object}
     */
    get main() {
        return this._main;
    }

    /**
     * @param {object} main
     */
    set main(main) {
        this._main = main;
    }

    /**
     * @return {object}
     */
    get local() {
        return this._local;
    }

    /**
     * @param {object} local
     */
    set local(local) {
        this._local = local;
    }

    /**
     * @return {Boolean}
     */
    get hasAvailableCompatibleServers() {
        return this._hasAvailableCompatibleServers;
    }

    /**
     * @param {Boolean} hasAvailableCompatibleServers
     */
    set hasAvailableCompatibleServers(hasAvailableCompatibleServers) {
        this._hasAvailableCompatibleServers = hasAvailableCompatibleServers;
    }

    /**
     * @return {String}
     */
    get note() {
        return this._note;
    }

    /**
     * @param {String} note
     */
    set note(note) {
        this._note = note;
    }

    /**
     * @return {Number}
     */
    get status() {
        return this._status;
    }

    /**
     * @param {Number} status
     */
    set status(status) {
        this._status = status;
    }

    /**
     * @return {Object}
     */
    clone() {
        let clone = new Database(
            this._uuid,
            this._masterUuid,
            this._name,
            this._main ? this._main.clone() : null,
            this._local,
            this._hasAvailableCompatibleServers,
            this._note,
            this._status
        );

        return clone;
    }

    /**
     * @return {String}
     */
    toString() {
        return "Database (" + this._name + ")";
    }
}
